export default {"id":"3864bb4b","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}